export enum LanguageSelectorContainerTypes {
    WORKFLOW_MODAL = "WorkflowModal",
    VERIFICATION_LINK_MODAL = "VerificationLinkModal",
}